import template from './viewChargeCodesModal.html';
import controller from './viewChargeCodesModal.controller';

let ViewChargeCodesModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

// Export template and controller separately for use with $uibModal.open()
ViewChargeCodesModalComponent.template = template;
ViewChargeCodesModalComponent.controller = controller;

export default ViewChargeCodesModalComponent;




// WEBPACK FOOTER //
// ./client/common/modals/viewChargeCodesModal/viewChargeCodesModal.component.js